export default __webpack_public_path__ + "static/media/Order.176df55b.jpg";